export default "__VITE_ASSET__B9UKcDDr__ 100w";